/**
 * @deprecated Usa FilePreviewExcelComponent da @sia/file-system
 * Questo componente e mantenuto per retrocompatibilita.
 */
export { FilePreviewExcelComponent as AiFilePreviewExcelComponent } from '@sia/file-system';
